export default "__VITE_ASSET__DjwwiW5g__"